<div>
  <h2 i18n="@@account.data">Dane mojego konta</h2>
  <form
    [formGroup]="accountForm"
    autocomplete="off"
  >
    <ppb-account-data-form [accountForm]="accountForm" [readonly]="readonly"></ppb-account-data-form>
  </form>
  <div
    *ngIf="(ialAboveLow() && (showChangeDataInfo$ | async))
    || (showEmailChanged$ | async)
    || (showPhoneChanged$ | async)
    || (isSharePhoneChanged$ | async)"
  >
    <p *ngIf="(showEmailChanged$ | async)"
       i18n="@@account.show_email_changed"
    >Zmiana adresu e-mail wymaga potwierdzenia za pomocą linka, który zostanie
      wysłany na podany adres. Do momentu
      potwierdzenia, w systemie będzie obowiązywał dotychczasowy adres e-mail. Jeśli nie znajdziesz wiadomości w
      skrzynce odbiorczej, sprawdź inne foldery.</p>
    <p *ngIf="(ialAboveLow() && (showChangeDataInfo$ | async)) || (showEmailChanged$ | async)"
       i18n="@@account.ial_above_low"
    >Zmiana danych osobowych będzie skutkować
      obniżeniem aktualnego poziomu
      sprawdzenia tożsamości do niskiego. Do
      czasu potwierdzenia tożsamości przez Administratora Bezpieczeństwa Partnera Biznesowego lub Administratora
      Uprawnień PSE, dostępność do wybranych funkcjonalności systemu może zostać ograniczona.</p>

    <p *ngIf="(showPhoneChanged$ | async)"
       i18n="@@account.show_phone_changed"
    >Zmiana numeru telefonu wymaga potwierdzenia dwoma kodami sms - pierwszy
      wysłany zostanie na dotychczasowy numer telefonu a drugi na nowy numer telefonu.</p>
    <div *ngIf="(isSharePhoneChanged$ | async)">
      <p *ngIf="(sharePhoneChangeValue$ | async)"
         i18n="@@account.share_phone_change_value"
      >Administratorzy Partnera Biznesowego uzyskają dostęp do Twojego numeru telefonu.</p>
      <p *ngIf="!(sharePhoneChangeValue$ | async)"
         i18n="@@account.no_share_phone_change_value"
      >Administratorzy Partnera Biznesowego utracą dostęp do Twojego numeru telefonu.</p>
    </div>
    <div [formGroup]="rulesConfirmForm">
      <label class="o-form-check" for="acceptInfo">
        <input
          id="acceptInfo"
          class="o-form-check__input"
          type="checkbox"
          formControlName="rulesConfirmed"
        >
        <span
          class="o-form-check__btn"
          i18n="@@account.accept_effects_details"
        >Akceptuje wymienione skutki zmiany danych konta</span>
      </label>
    </div>
  </div>
  <div
    *ngIf="isDataChanged$ | async"
    fxLayout="row"
    fxLayoutAlign="end center"
    fxLayoutGap="24px"
  >
    <button class="o-btn o-btn--secondary o-btn--small"
            type="button"
            [disabled]="isConfirmButtonLoading$ | async"
            (click)="abortDataChange()"
            i18n="@@common.cancel"
    >Anuluj
    </button>
    <pseic-async-button
      [isDisabled$]="isButtonDisabled$"
      [isLoading$]="isConfirmButtonLoading$"
      (buttonClicked)="confirmDataChange()"
      i18n="@@common.confirm"
    >Potwierdź
    </pseic-async-button>
  </div>
</div>

<ng-template #smsCodeTemplate>
  <div [formGroup]="smsConfirmForm">
    <div fxLayout="row"
         fxLayoutAlign="start center"
         fxLayoutGap="24px">
      <div>
        <pseic-form-field [labelFor]="'currentPhoneSmsCode'" [label]="getCurrentPhoneSmsCodeLabel(isPhoneChanged)" [resizeOnError]="true">
          <input
            class="o-form-field auth-code"
            placeholder="Kod SMS"
            id="currentPhoneSmsCode"
            formControlName="currentPhoneSmsCode"
            pseicAutofocus="true"
            type="number"
            (keypress)="submitOnEnter($event)"
            i18n-placeholder="@@common.sms_code"
          >
        </pseic-form-field>
      </div>
    </div>
    <div
      *ngIf="isPhoneChanged"
      fxLayout="row"
         fxLayoutAlign="start center"
         fxLayoutGap="24px">
      <div>
        <pseic-form-field [labelFor]="'newPhoneSmsCode'" [label]="getNewPhoneSmsCodeLabel()" [resizeOnError]="true">
          <input
            class="o-form-field auth-code"
            placeholder="Kod SMS"
            id="newPhoneSmsCode"
            formControlName="newPhoneSmsCode"
            type="number"
            (keypress)="submitOnEnter($event)"
            i18n-placeholder="@@common.sms_code"
          >
        </pseic-form-field>
      </div>
    </div>
  </div>
</ng-template>
